/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employee_absences_AbsenceCertificateDownloadResponse } from '../models/employee_absences_AbsenceCertificateDownloadResponse';
import type { employee_absences_AbsenceCertificateListResponse } from '../models/employee_absences_AbsenceCertificateListResponse';
import type { employee_absences_AbsenceListResponse } from '../models/employee_absences_AbsenceListResponse';
import type { employee_absences_AbsencePatternListResponse } from '../models/employee_absences_AbsencePatternListResponse';
import type { employee_absences_AbsencePatternResponse } from '../models/employee_absences_AbsencePatternResponse';
import type { employee_absences_AbsenceResponse } from '../models/employee_absences_AbsenceResponse';
import type { employee_absences_CancelReportRequest } from '../models/employee_absences_CancelReportRequest';
import type { employee_absences_CreateAbsenceRequest } from '../models/employee_absences_CreateAbsenceRequest';
import type { employee_absences_CreateRecurringAbsenceRequest } from '../models/employee_absences_CreateRecurringAbsenceRequest';
import type { employee_absences_PendingAbsenceCountResponse } from '../models/employee_absences_PendingAbsenceCountResponse';
import type { employee_absences_RecurringAbsenceCreatedResponse } from '../models/employee_absences_RecurringAbsenceCreatedResponse';
import type { employee_absences_RecurringAbsenceUpdatedResponse } from '../models/employee_absences_RecurringAbsenceUpdatedResponse';
import type { employee_absences_RejectAbsenceRequest } from '../models/employee_absences_RejectAbsenceRequest';
import type { employee_absences_UpdateAbsenceRequest } from '../models/employee_absences_UpdateAbsenceRequest';
import type { employee_absences_UpdateRecurringAbsenceRequest } from '../models/employee_absences_UpdateRecurringAbsenceRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeeAbsencesService {
    /**
     * List employee absences
     * List employee absences with optional filtering and pagination
     * @param employeeId Filter by employee ID
     * @param absenceType Filter by absence type (VACATION, SICK, PERSONAL, TRAINING, OTHER, ACCIDENT, COMP_TIME, CHILD_SICK)
     * @param approvalStatus Filter by approval status (REQUESTED, APPROVED, REJECTED, CANCELLED)
     * @param isSelfReport Filter self-reported absences (true) or office/requests (false)
     * @param acknowledged Filter reports the office acknowledged (true) or not (false)
     * @param certificateStatus Filter by certificate status (NOT_DUE, DUE, PROVIDED, EAU_RETRIEVED, NOT_REQUIRED)
     * @param fromDate Filter absences that overlap with this date range (YYYY-MM-DD)
     * @param toDate Filter absences that overlap with this date range (YYYY-MM-DD)
     * @param limit Maximum number of results (default: 20, max: 100)
     * @param offset Offset for pagination (default: 0)
     * @returns employee_absences_AbsenceListResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsences(
        employeeId?: string,
        absenceType?: string,
        approvalStatus?: string,
        isSelfReport?: boolean,
        acknowledged?: boolean,
        certificateStatus?: string,
        fromDate?: string,
        toDate?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<employee_absences_AbsenceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences',
            query: {
                'employee_id': employeeId,
                'absence_type': absenceType,
                'approval_status': approvalStatus,
                'is_self_report': isSelfReport,
                'acknowledged': acknowledged,
                'certificate_status': certificateStatus,
                'from_date': fromDate,
                'to_date': toDate,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Invalid filter (field map)`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list absences`,
            },
        });
    }
    /**
     * Create a new employee absence
     * Create a new employee absence record (vacation, sick leave, personal day, training, or other)
     * @param request Absence to create
     * @returns employee_absences_AbsenceResponse Created
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsences(
        request: employee_absences_CreateAbsenceRequest,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                409: `Absence overlaps with existing absence`,
                422: `Absence covers too many days`,
                500: `Failed to create absence`,
            },
        });
    }
    /**
     * Delete an absence
     * Soft delete an employee absence
     * @param id Absence ID
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1EmployeeAbsences(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/employee-absences/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing absence ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                404: `Absence not found`,
                500: `Failed to delete absence`,
            },
        });
    }
    /**
     * Get absence by ID
     * Get a single employee absence by ID with employee details
     * @param id Absence ID
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsences1(
        id: string,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing absence ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Absence not found`,
                500: `Failed to get absence`,
            },
        });
    }
    /**
     * Update an existing absence
     * Update an existing employee absence with optimistic locking
     * @param id Absence ID
     * @param request Updated absence data
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static putApiV1EmployeeAbsences(
        id: string,
        request: employee_absences_UpdateAbsenceRequest,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/employee-absences/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                404: `Absence not found`,
                409: `Absence overlaps with existing absence, optimistic lock failed, or a report changed concurrently (ABSENCE_REPORT_CONFLICT) or is no longer active (ABSENCE_REPORT_NOT_ACTIVE)`,
                422: `Absence covers too many days, or an accident report lacks its accident fields (ACCIDENT_FIELDS_REQUIRED)`,
                500: `Failed to update absence`,
            },
        });
    }
    /**
     * Acknowledge a self-reported absence
     * Marks the employee's report as seen by the office (issue #1767). Idempotent: an acknowledged report answers 200 unchanged. Nobody acknowledges their own report.
     * @param id Absence ID
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesAcknowledge(
        id: string,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/{id}/acknowledge',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid absence id`,
                401: `Authentication required`,
                403: `Own absence (ABSENCE_SELF_DECISION) or module access required`,
                404: `Absence not found`,
                409: `Not a report (ABSENCE_NOT_SELF_REPORT) or not active (ABSENCE_REPORT_NOT_ACTIVE)`,
                500: `Failed to acknowledge report`,
            },
        });
    }
    /**
     * Approve an absence request
     * Approve a pending absence request
     * @param id Absence ID
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesApprove(
        id: string,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/{id}/approve',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing absence ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a decision on one's own absence (the four-eyes check answers ABSENCE_SELF_DECISION)`,
                404: `Absence not found`,
                409: `Absence is not in pending state`,
                500: `Failed to approve absence`,
            },
        });
    }
    /**
     * Cancel an absence request
     * Cancel a pending absence request
     * @param id Absence ID
     * @returns void
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesCancel(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing absence ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                404: `Absence not found`,
                409: `Absence is not in pending state`,
                500: `Failed to cancel absence`,
            },
        });
    }
    /**
     * Cancel a self-reported absence
     * Cancels the employee's report with a reason (issue #1767). The Zeitkonto is recomputed; cancelled shifts are not restored. Nobody cancels their own report.
     * @param id Absence ID
     * @param request Cancel reason
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesCancelReport(
        id: string,
        request: employee_absences_CancelReportRequest,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/{id}/cancel-report',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid absence id or request format`,
                401: `Authentication required`,
                403: `Own absence (ABSENCE_SELF_DECISION) or module access required`,
                404: `Absence not found`,
                409: `Not a report or not active`,
                422: `Reason missing or too long`,
                500: `Failed to cancel report`,
            },
        });
    }
    /**
     * List the certificates of a reported absence
     * Lists the confirmed doctor's certificates of an absence, metadata only (issue #1767). Admins and `employees` holders only. Every call writes one access-log row.
     * @param id Absence ID
     * @returns employee_absences_AbsenceCertificateListResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsencesCertificates(
        id: string,
    ): CancelablePromise<employee_absences_AbsenceCertificateListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/{id}/certificates',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid absence id`,
                401: `Authentication required`,
                403: `Module access required`,
                404: `Absence not found`,
                500: `Failed to list certificates`,
                503: `Certificate storage unavailable`,
            },
        });
    }
    /**
     * Get a 5-minute URL for one certificate
     * Returns a 5-minute download URL of one certificate of the absence (issue #1767). disposition=attachment (default) downloads and logs "download"; disposition=inline opens it in the browser and logs "view". Any other value or any other query parameter answers 400. Admins and `employees` holders only.
     * @param id Absence ID
     * @param imageId Certificate ID
     * @param disposition attachment (default) or inline
     * @returns employee_absences_AbsenceCertificateDownloadResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsencesCertificatesDownload(
        id: string,
        imageId: string,
        disposition?: 'attachment' | 'inline',
    ): CancelablePromise<employee_absences_AbsenceCertificateDownloadResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/{id}/certificates/{imageId}/download',
            path: {
                'id': id,
                'imageId': imageId,
            },
            query: {
                'disposition': disposition,
            },
            errors: {
                400: `Invalid id or query (field map)`,
                401: `Authentication required`,
                403: `Module access required`,
                404: `Certificate not found`,
                500: `Failed to create download URL`,
                503: `Certificate storage unavailable`,
            },
        });
    }
    /**
     * Mark the electronic certificate (eAU) of a report as retrieved
     * EAU mode only (issue #1767): records that the office retrieved the electronic certificate from the health insurer. Idempotent. Answers 409 CERTIFICATE_MODE_NOT_EAU in UPLOAD mode.
     * @param id Absence ID
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesEauRetrieved(
        id: string,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/{id}/eau-retrieved',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid absence id`,
                401: `Authentication required`,
                403: `Own absence (ABSENCE_SELF_DECISION) or module access required`,
                404: `Absence not found`,
                409: `UPLOAD mode, not a report or not active`,
                500: `Failed to mark eAU retrieved`,
            },
        });
    }
    /**
     * Reject an absence request
     * Reject a pending absence request with a reason
     * @param id Absence ID
     * @param request Rejection reason
     * @returns employee_absences_AbsenceResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesReject(
        id: string,
        request: employee_absences_RejectAbsenceRequest,
    ): CancelablePromise<employee_absences_AbsenceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/{id}/reject',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Invalid request or missing fields`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a decision on one's own absence (the four-eyes check answers ABSENCE_SELF_DECISION)`,
                404: `Absence not found`,
                409: `Absence is not in pending state`,
                500: `Failed to reject absence`,
            },
        });
    }
    /**
     * List absence patterns
     * List absence patterns with optional employee filter and pagination
     * @param employeeId Filter by employee ID
     * @param limit Maximum number of results (default: 20, max: 100)
     * @param offset Offset for pagination (default: 0)
     * @returns employee_absences_AbsencePatternListResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsencesPatterns(
        employeeId?: string,
        limit?: number,
        offset?: number,
    ): CancelablePromise<employee_absences_AbsencePatternListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/patterns',
            query: {
                'employee_id': employeeId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list patterns`,
            },
        });
    }
    /**
     * Delete a recurring absence pattern
     * Delete a recurring absence pattern and its associated absences
     * @param id Pattern ID
     * @param scope Delete scope: 'all' or 'future' (default: all)
     * @returns void
     * @throws ApiError
     */
    public static deleteApiV1EmployeeAbsencesPatterns(
        id: string,
        scope?: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/employee-absences/patterns/{id}',
            path: {
                'id': id,
            },
            query: {
                'scope': scope,
            },
            errors: {
                400: `Invalid or missing pattern ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                404: `Pattern not found`,
                500: `Failed to delete pattern`,
            },
        });
    }
    /**
     * Get an absence pattern by ID
     * Get a single absence pattern by ID
     * @param id Pattern ID
     * @returns employee_absences_AbsencePatternResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsencesPatterns1(
        id: string,
    ): CancelablePromise<employee_absences_AbsencePatternResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/patterns/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid or missing pattern ID`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                404: `Pattern not found`,
                500: `Failed to get pattern`,
            },
        });
    }
    /**
     * Update a recurring absence pattern
     * Update a recurring absence pattern and regenerate concrete absence entries
     * @param id Pattern ID
     * @param request Updated recurring absence data
     * @returns employee_absences_RecurringAbsenceUpdatedResponse OK
     * @throws ApiError
     */
    public static putApiV1EmployeeAbsencesPatterns(
        id: string,
        request: employee_absences_UpdateRecurringAbsenceRequest,
    ): CancelablePromise<employee_absences_RecurringAbsenceUpdatedResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/employee-absences/patterns/{id}',
            path: {
                'id': id,
            },
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                404: `Pattern not found`,
                500: `Failed to update recurring absence`,
            },
        });
    }
    /**
     * List pending absence requests
     * List absences with REQUESTED approval status for the approval queue
     * @param limit Maximum number of results (default: 20, max: 100)
     * @param offset Offset for pagination (default: 0)
     * @param forMe Only items routed to the caller as approver (#1767)
     * @returns employee_absences_AbsenceListResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsencesPending(
        limit?: number,
        offset?: number,
        forMe?: boolean,
    ): CancelablePromise<employee_absences_AbsenceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/pending',
            query: {
                'limit': limit,
                'offset': offset,
                'for_me': forMe,
            },
            errors: {
                400: `Invalid parameter (field map)`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to list pending absences`,
            },
        });
    }
    /**
     * Count pending absence requests
     * Get the count of pending absence requests for badge display
     * @param forMe Only items routed to the caller as approver (#1767)
     * @returns employee_absences_PendingAbsenceCountResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeAbsencesPendingCount(
        forMe?: boolean,
    ): CancelablePromise<employee_absences_PendingAbsenceCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee-absences/pending/count',
            query: {
                'for_me': forMe,
            },
            errors: {
                400: `Invalid parameter (field map)`,
                401: `Authentication required`,
                403: `Organization ID not found in token`,
                500: `Failed to count pending absences`,
            },
        });
    }
    /**
     * Create a recurring absence
     * Create a recurring absence pattern and generate concrete absence entries
     * @param request Recurring absence to create
     * @returns employee_absences_RecurringAbsenceCreatedResponse Created
     * @throws ApiError
     */
    public static postApiV1EmployeeAbsencesRecurring(
        request: employee_absences_CreateRecurringAbsenceRequest,
    ): CancelablePromise<employee_absences_RecurringAbsenceCreatedResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee-absences/recurring',
            body: request,
            errors: {
                400: `Validation errors or invalid request format`,
                401: `Authentication required`,
                403: `Organization ID not found in token, or a non-admin writes their own absence`,
                500: `Failed to create recurring absence`,
            },
        });
    }
}
